import React from 'react';
import { Headphones } from 'lucide-react';

const RAZONES = {
  ia_solicitud: 'Pedido a la IA', archivo_espontaneo: 'Envió un archivo', takeover_humano: 'Pidió hablar con una persona',
  notificacion_auxiliares: 'Respuesta a notificación de Auxiliares', crm_iniciado: 'Iniciada desde el CRM',
  tomado_desde_crm: 'Tomada desde el CRM', broadcast_proactivo: 'Respuesta a broadcast',
  campana_portal: 'Campaña portal',
};

const fmtMonto = (n) => `$${Number(n).toLocaleString('es-AR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export const CRMTakeoverMotivo = ({ tk }) => {
  if (!tk) return null;
  const d = tk.datos_solicitud || {};
  const motivo = tk.motivo || RAZONES[tk.razon] || tk.razon;
  const deuda = d.deuda === undefined || d.deuda === null ? (d.deuda_error ? 'no disponible' : null) : fmtMonto(d.deuda);
  const items = [['Nombre', d.nombre], ['DNI', d.dni], ['Matrícula', d.mp], ['Deuda', deuda], ['Detalle', d.detalle]]
    .filter(([, v]) => v !== undefined && v !== null && v !== '');
  if (!motivo && !items.length) return null;
  return (
    <div className="px-3 py-2 border-b bg-orange-50 text-xs flex flex-wrap items-center gap-x-4 gap-y-1" data-testid="crm-takeover-motivo">
      {motivo && (
        <span className="flex items-center gap-1 font-semibold text-orange-800" data-testid="crm-takeover-motivo-texto">
          <Headphones className="w-3.5 h-3.5" /> Motivo: <span>{motivo.charAt(0).toUpperCase() + motivo.slice(1)}</span>
        </span>
      )}
      {items.map(([k, v]) => (
        <span key={k} className="text-gray-700" data-testid={`crm-takeover-dato-${k.toLowerCase()}`}>
          <span className="text-gray-500">{k}:</span> <span className="font-medium">{v}</span>
        </span>
      ))}
    </div>
  );
};
